<template>
  <div>
    <HeaderTop :isBackgroundShow="isBackgroundShow"  page="home" :isBlack="true" :homeTitle="infoHtml.title.length > 5 ? infoHtml.title.substr(0, 5) + '...' : infoHtml.title"></HeaderTop>
    <div :class="this.pageWidth <= 1280 ? 'mobileContent content' : 'content'" @scroll="handleScroll">
      <!--        <div class="banner">-->
      <!--          <img :src="bannerImgUrl" alt="">-->
      <!--        </div>-->
      <div class="list">
        <div class="title">
          <img src="../assets/img/itemimage/returnbtn.png" class="return" alt="" @click="toBack"
               v-if="this.pageWidth > 1280">
          {{ infoHtml.title }}
        </div>
        <div class="subtitle" v-if="this.pageWidth > 1280">
          {{ infoHtml.createtime }}
        </div>
        <div class="content" v-html="infoHtml.content">

        </div>
      </div>
    </div>
    <float-element :showTop="showTop"></float-element>
    <Bottom></Bottom>
  </div>
</template>

<script>
import HeaderTop from "@/components/headerTop"
import Bottom from "@/components/bottom"
import Pagination from '@/components/pagination';
import FloatElement from "@/components/floatElement";

export default {
  name: "imglist",
  components: {
    HeaderTop,
    Bottom,
    Pagination,
    FloatElement
  },
  data() {
    return {
      infoHtml: {},
      bannerImgUrl: null,
      pageWidth: 0,
      showTop: false,
      isBackgroundShow: true,
    }
  },

  created() {
    this.currentId = this.$route.query.id
    this.getDetail()

  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听器
  },
  destroyed() {

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
    this.pageWidth = document.documentElement.clientWidth
  },
  methods: {
    handleScroll(event) {
      const scrollTop = window.scrollY; // 获取滚动条相对于文档顶部的距离
      // 产品中心
      if (scrollTop >= 10) {
        this.showTop = true
        // this.isBackgroundShow = true
      } else {
        this.showTop = false
        // this.isBackgroundShow = false
      }
    },
    // 获取内容详情
    getDetail() {
      this.$API.InterfaceConfigurationPage._getArticleDetail({
        params: {
          id: this.currentId
        }
      }).then(res => {
        if (res.success) {
          this.infoHtml = res.data
        } else {
          this.$Message.info('系统错误')
        }
      }).catch(err => {
        console.log('获取失败===', err);
      });
    },
    // 返回上一页
    toBack() {
      this.$router.go(-1)
    }

  }
}

</script>
<style>
@media screen and (max-width: 1280px) {
  .content {
    .list {
      .content {
        text-align: left !important;;
        margin: 30px auto !important;;
        padding: 0 30px !important;;
        font-family: Microsoft YaHei !important;;
        font-weight: 400 !important;;
        font-size: 24px !important;
        text-size-adjust: none !important;;
        color: #333333 !important;;
        text-align: left !important;;

        span {
          font-family: Microsoft YaHei;
          font-weight: 400 !important;;
          font-size: 24px !important;;
          text-size-adjust: none !important;;
          color: #333333 !important;;
          text-align: left !important;;
        }

        p {
          line-height: 28px !important;;
          text-align: left !important;;
          margin: 10px 0 !important;;
          font-family: Microsoft YaHei;
          font-weight: 400 !important;;
          font-size: 24px !important;;
          text-size-adjust: none !important;;
          color: #333333 !important;;
        }

        img {
          text-align: center !important;
          width: 100% !important;;
        }
      }
    }
  }
}
@media screen and (min-width: 1281px) {
  .content {
    .list {
      .content {
        text-align: left !important;;
        margin: 30px auto !important;;
        padding: 0 30px !important;;
        font-family: Microsoft YaHei !important;;
        font-weight: 400 !important;;
        font-size: 24px !important;;
        text-size-adjust: none !important;;
        color: #333333 !important;;
        text-align: left !important;;

        span {
          font-family: Microsoft YaHei;
          font-weight: 400 !important;;
          font-size: 24px !important;;
          text-size-adjust: none !important;;
          color: #333333 !important;;
          text-align: left !important;;
        }

        p {
          line-height: 28px !important;;
          text-align: left !important;;
          margin: 10px 0 !important;;
          font-family: Microsoft YaHei !important;;
          font-weight: 400 !important;;
          font-size: 24px !important;;
          text-size-adjust: none !important;;
          color: #333333 !important;;
        }

        img {
          text-align: center !important;

        }
      }
    }
  }
}
</style>

<style scoped lang="less">

//移动端
.mobileContent {
  margin-top: 96px;
}
.content {
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 300px;

  .banner {
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .list {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    .title {
      width: 100%;
      //height: 40px;
      margin: 30px auto 5px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 27px;
      text-size-adjust: none;
      color: #5280B6;

      .return {
        float: left;
        width: 31px;
      }
    }

    .subtitle {
      text-align: center;
      font-size: 18px;
      text-size-adjust: none;
      color: rgba(82, 128, 182, 0.5);
    }

    .content {
      text-align: center;
      margin: 30px auto;
      padding: 0 30px;

      span {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 24px;
        text-size-adjust: none;
        color: #333333;
      }

      p {
        line-height: 28px;
        text-align: left;
        margin: 10px 0;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 24px;
        text-size-adjust: none;
        color: #333333;
      }

      img {
        text-align: center;
      }
    }

  }
}

//PC端
@media screen and (min-width: 1280px) {
  .content {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 0px;
    text-align: center;

    .banner {
      width: 100%;
      height: 500px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .list {
      width: 1280px;
      margin: 10px auto;
      padding-top: 100px;
      .title {
        width: 100%;
        //height: 40px;
        margin: 20px auto 5px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 26px;
        color: #5280B6;

        .return {
          float: left;
          width: 31px;
          cursor: pointer;
          margin-top: 5px;
        }
      }

      .subtitle {
        text-align: center;
        font-size: 18px;
        color: rgba(82, 128, 182, 0.5);
      }

      .content {
        width: 100%;
        text-align: left;
        min-height: 500px;

        p {
          line-height: 28px;
          text-align: left;
          font-size: 16px;
          margin: 10px 0;
        }

        img {
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/InformationDynamicsDetail.vue